import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store } from './store';
import { BrowserRouter } from 'react-router-dom';  // Keep BrowserRouter here
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { init as initPwaInstall } from './Utils/pwaInstall';

// Chrome can fire `beforeinstallprompt` before React mounts, so start listening
// for it here rather than inside a component.
initPwaInstall();

// Benign browser warning (common with password managers / layout), not an app bug.
// Without this, CRA/webpack shows a full-screen red overlay in development.
window.addEventListener('error', (event) => {
  if (
    event.message?.includes('ResizeObserver loop completed with undelivered notifications') ||
    event.message?.includes('ResizeObserver loop limit exceeded')
  ) {
    event.stopImmediatePropagation();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
// window.getPublicUrl = (path) => `${process.env.PUBLIC_URL}/${path}`;
const publicUrl = process.env.PUBLIC_URL || "";

window.getPublicUrl = (path) =>
  publicUrl ? `${publicUrl}/${path}` : path;
root.render(
  <Provider store={store}>
    <BrowserRouter>  {/* BrowserRouter here */}
      <App />
    </BrowserRouter>
  </Provider>
);

// Makes the app installable and lets it open offline (production builds only).
serviceWorkerRegistration.register();

reportWebVitals();
